import { motion } from "framer-motion";
import { Skull, Repeat, TrendingUp } from "lucide-react";

const PILLARS = [
  {
    icon: Skull,
    title: "Train Like You Mean It",
    text: "A 4-day Upper/Lower hypertrophy split engineered for maximum muscle damage and full recovery. Every session has a purpose — no filler, no fluff.",
  },
  {
    icon: Repeat,
    title: "8-Week War Cycle",
    text: "Structured progressive overload across 8 weeks. Loads, reps and intensity techniques evolve week by week so your body never adapts and never stalls.",
  },
  {
    icon: TrendingUp,
    title: "Track Everything",
    text: "A built-in overload tracking log turns every workout into data. If the numbers go up, so do you. Simple, brutal, effective.",
  },
];

export const ProgramOverview = () => {
  return (
    <section id="program" className="py-24 sm:py-32 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <p className="section-label mb-4">// THE METHOD //</p>
        <h2 className="font-anton text-4xl sm:text-5xl uppercase tracking-tight mb-16">
          Built in the <span className="red-text">hole</span>, forged for the <span className="neon-text">grind</span>
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              className="card-ady p-8 hover:border-[#39FF14] transition-colors group"
              data-testid={`overview-card-${i}`}
            >
              <p.icon className="text-[#D90429] mb-6 group-hover:text-[#39FF14] transition-colors" size={36} />
              <h3 className="font-bebas text-2xl tracking-[0.1em] mb-4">{p.title}</h3>
              <p className="text-[#A1A1AA] text-sm leading-relaxed">{p.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
